import { Fragment, lazy, Suspense } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { RouteConstants } from "./RouteConstants";
import Login from "pages/login/Login";
import { getItemFromLocalStorage } from "../utils/LocalStorageUtils";
import { Constants } from "constants/Constants";
import ProtectedRoute from "./ProtectedRoutes";
import MediaBulkUpload from "../pages/project-management/media-upload-list/bulk-upload/BulkUpload";
import { RoleTypeEnum } from "enumerations/RoleTypeEnum";
import Loader from "components/loader/Loader";
const PortalDashboard = lazy(() => import("../pages/portal-dashboard/PortalDashboard"));
const ProjectCreation = lazy(() => import("../pages/project-management/project-creation/ProjectContentCreation"));
const ProjectList = lazy(() => import("../pages/project-management/project-list/ProjectList"));
const PromiseCreation = lazy(() => import("../pages/promise-management/promise-creation/PromiseCreation"));
const PromiseList = lazy(() => import("../pages/promise-management/promise-list/PromiseList"));
const UserCreation = lazy(() => import("../pages/user-management/user-creation/UserCreation"));
const UserList = lazy(() => import("../pages/user-management/user-list/UserList"));
const UserLog = lazy(() => import("../pages/user-management/user-log/UserLog"));
const ReferralCardList = lazy(() => import("../pages/marketing-management/referral-cards/referral-card-list/ReferralCardList"));
const ReferralCardCreation = lazy(() => import("../pages/marketing-management/referral-cards/referral-card-creation/ReferralCardCreation"));
const NudgeCardList = lazy(() => import("../pages/marketing-management/nudge-cards/nudge-card-list/NudgeCardList"));
const NudgeCardCreation = lazy(() => import("../pages/marketing-management/nudge-cards/nudge-card-creation/NudgeCardCreation"));
const UpdateCreation = lazy(() => import("../pages/marketing-management/updates/update-creation/UpdatesCreation"));
const UpdateList = lazy(() => import("../pages/marketing-management/updates/update-list/UpdateList"));
const FAQList = lazy(() => import("../pages/resource-management/faq/faq-list/FAQList"));
const FAQCreation = lazy(() => import("../pages/resource-management/faq/faq-creation/FAQCreation"));
const InsightList = lazy(() => import("../pages/resource-management/insights/insights-list/InsightList"));
const InsightsCreation = lazy(() => import("../pages/resource-management/insights/insights-creation/InsightsCreation"));
const PromotionsAndOffersCreation = lazy(() => import("../pages/marketing-management/promotions-and-offers/promotions-and-offers-creation/PromotionsAndOffersCreation"));
const PromotionsAndOffersList = lazy(() => import("../pages/marketing-management/promotions-and-offers/promotions-and-offers-list/PromotionsAndOffersList"));
const TestimonialCreation = lazy(() => import("../pages/marketing-management/testimonials/testimonial-creation/TestimonialCreation"));
const TestimonialList = lazy(() => import("../pages/marketing-management/testimonials/testimonial-list/TestimonialList"));
const AuditLog = lazy(() => import("../pages/user-management/audit-log/AuditLog"));
const MediaUploadList = lazy(() => import("../pages/project-management/media-upload-list/MediaUploadList"));
const ProjectCollectionList = lazy(() => import("../pages/project-management/project-collection-list/ProjectCollectionList"));
const ProjectCollectionCreation = lazy(() => import("../pages/project-management/project-collection-creation/ProjectCollectionCreation"));
const UserManagementDashboard = lazy(() => import("../pages/user-management/user-management-dashboard/UserManagmentDashboard"));
const ProjectManagementDashboard = lazy(() => import("../pages/project-management/project-management-dashboard/ProjectManagementDashboard"));
const PromiseManagementDashboard = lazy(() => import("../pages/promise-management/promise-management-dashboard/PromiseManagementDashboard"));
const ResourceManagementDashboard = lazy(() => import("../pages/resource-management/resource-management-dashboard/ResourceManagementDashboard"));
const MarketingManagementDashboard = lazy(() => import("../pages/marketing-management/marketing-management-dashboard/MarketingManagementDashboard"));
const PageManagementDashboard = lazy(() => import("pages/page-management/page-management-dashboard/PageManagementDashboard"));
const Page1Hoabl = lazy(() => import("pages/page-management/page-management-dashboard/page-1-hoabl/Page1Hoabl"));
const Page3Promises = lazy(() => import("pages/page-management/page-management-dashboard/page-3-promises/Page3Promises"));
const Investment = lazy(() => import("pages/page-management/page-management-dashboard/investments/Investment"));
const Page5Profile = lazy(() => import("../pages/page-management/page-management-dashboard/page-5-profile/Page5Profile"));
const Page4Portfolio = lazy(() => import("pages/page-management/page-management-dashboard/page-4-portfolio/Page4Portfolio"));
const FooterTabs = lazy(() => import("pages/page-management/page-management-dashboard/page-6-footer-tabs/FooterTabs"));
const NotificationList = lazy(() => import("pages/notification-management/notification-list/NotificationList"));
const NotificationManagementDashboard = lazy(() => import("pages/notification-management/notification-management-dashboard/NotificationManagementDashboard"));
const CreateNotification = lazy(() => import("pages/notification-management/notification-list/create-notification/CreateNotification"));
const AppUpdates = lazy(() => import("pages/notification-management/app-updates/AppUpdates"));
const CreateAppUpdate = lazy(() => import("pages/notification-management/app-updates/CreateAppUpdate"));
const ChatSupportManagement = lazy(() => import("pages/chat-management/ChatSupportManagement"));
const HoablNewUser = lazy(() => import("pages/chat-management/hoabl-new-user/HoablNewUser"));
const HoablInvestedUser = lazy(() => import("pages/chat-management/hoabl-invested-user/HoablInvestedUser"));
const ProjectsNewUser = lazy(() => import("pages/chat-management/projects-new-user/ProjectsNewUser"));
const ProjectsInvestedUser = lazy(() => import("pages/chat-management/projects-invested-user/ProjectsInvestedUser"));
const SchedulingVC = lazy(() => import("pages/chat-management/scheduling-vc/SchedulingVC"));
const CustomerList = lazy(() => import("pages/customer-management/customer-list/CustomerList"));
const CustomerFeedback = lazy(() => import("pages/customer-management/customer-list/customer-feedback/CustomerFeedback"));
const BlockedCustomersList = lazy(() => import("pages/customer-management/customer-list/blocked-customer-list/BlockedCustomersList"));
const CustomerView = lazy(() => import("pages/customer-management/customer-list/customer-view/CustomerView"));
const CustomerInvestmentDetails = lazy(() => import("pages/customer-management/customer-list/customer-view/customer-view-components/customer-investment-details/CustomerInvestmentDetails"));
const BlogCreation = lazy(() => import("pages/blog-management/blog-creation/BlogCreation"));
const BlogManagementDashboard = lazy(() => import("pages/blog-management/blog-management-dashboard/BlogManagementDashboard"));
const BlogList = lazy(() => import("pages/blog-management/blog-listing/BlogList"));
const LandingPageManagementDashboard = lazy(() => import("pages/landing-page-management/landing-page-management-dashboard/LandingPageManagementDashboard"));
const LandingPageUrlCreation = lazy(() => import("pages/landing-page-management/landing-page-url-creation"));
const UrlList = lazy(() => import("pages/landing-page-management/UrlList"));
const PaymentFormManagement = lazy(() => import("pages/payment-form-management/PaymentFormManagement"));
const Projects = lazy(() => import("pages/payment-form-management/projects/Projects"));
const ProjectFormList = lazy(() => import("pages/payment-form-management/form-listing/ProjectFormList"));
const UpcommingProject = lazy(() => import("pages/project-management/project-creation/upcomming-projects/UpcommingProject"));
const SingleUpcommingProject = lazy(() => import("pages/project-management/project-list/upcomming-project/SingleUpcommingProject"));
const UpdateUpcommingProject = lazy(() => import("pages/project-management/project-creation/upcomming-projects/UpdateUpcommingProject"));
const LeadsList = lazy(() => import("pages/leads-managements/LeadsList"));
const MediaAndPrCreation = lazy(() => import("pages/marketing-management/media-and-pr/MediaAndPrCreation"));
const MediaAndPrList = lazy(() => import("pages/marketing-management/media-and-pr/MediaAndPrList"));
const QrCodeGeneration = lazy(() => import("pages/resource-management/qr-generator/qrGeneratedList"));

// import PaymentHistoryListing from "pages/payment-history/PaymentHistoryListing/ProjectFormList";
// import PaymentHistory from "pages/payment-history/PaymentHistory";

// const actionDispatch = (dispatch: any) => {
//   return {
//     setUsersState: (key: any, data: any) =>
//       dispatch(UserActions.setUsersState(key, data)),
//   };
// };

const AppRoutes = () => {
  let routes = (
    <Fragment>
      <Route path="/" element={<Login />} />
      <Route path={RouteConstants.login} element={<Login />} />
      <Route path="*" element={<Navigate to="/" />} />
      <Route path={RouteConstants.resetPassword} element={<Login />} />
    </Fragment>
  );

  const token = getItemFromLocalStorage(Constants.authorizationToken);
  const getInitialRouteAfterLogin = () => {
    const loggedInUser = getItemFromLocalStorage(Constants.loggedInUser);
    if (
      loggedInUser &&
      loggedInUser.admin &&
      loggedInUser.admin.roleId === RoleTypeEnum.Admin
    ) {
      const sidemenu = loggedInUser?.sideMenuList
        ? loggedInUser?.sideMenuList
        : [];
      return sidemenu[0].route;
    } else {
      return RouteConstants.userManagementDashboard;
    }
  };

  if (token) {
    routes = (
      <Route element={<ProtectedRoute />}>
        {/*===============================================
        ==========Portal Dashboard Routes=============
        ==================================================*/}
        <Route
          path={RouteConstants.portalDashboard}
          element={<PortalDashboard />}
        />
        {/*===============================================
        ==========User Management Routes=============
        ==================================================*/}
        <Route
          path={RouteConstants.userManagementDashboard}
          element={<UserManagementDashboard />}
        />
        <Route path={RouteConstants.userList} element={<UserList />} />
        <Route path={RouteConstants.userCreation} element={<UserCreation />} />
        <Route path={RouteConstants.updateUser} element={<UserCreation />} />
        <Route path={RouteConstants.userLog} element={<UserLog />} />
        <Route path={RouteConstants.auditLog} element={<AuditLog />} />
        {/*===============================================
        ==========Project Management Routes=============
        ==================================================*/}
        <Route
          path={RouteConstants.projectManagementDashboard}
          element={<ProjectManagementDashboard />}
        />
        <Route
          path={`${RouteConstants.projectCreation}/*`}
          element={<ProjectCreation />}
        />
        <Route path={RouteConstants.projectList} element={<ProjectList />} />
        <Route
          path={RouteConstants.mediaUploadList}
          element={<MediaUploadList />}
        />
        <Route
          path={RouteConstants.mediaBulkUpload}
          element={<MediaBulkUpload />}
        />
        <Route
          path={RouteConstants.projectCollections}
          element={<ProjectCollectionList />}
        />
        <Route
          path={RouteConstants.projectCollectionCreation}
          element={<ProjectCollectionCreation />}
        />
        {/*===============================================
        ==========Page Management Routes=============
        ==================================================*/}
        <Route
          path={RouteConstants.pageManagementDashboard}
          element={<PageManagementDashboard />}
        />
        <Route path={RouteConstants.page1Hoabl} element={<Page1Hoabl />} />
        <Route
          path={RouteConstants.page2Investments}
          element={<Investment />}
        />
        <Route
          path={RouteConstants.page3Promises}
          element={<Page3Promises />}
        />
        <Route
          path={RouteConstants.page4Portfolio}
          element={<Page4Portfolio />}
        />
        <Route path={RouteConstants.page5Profile} element={<Page5Profile />} />
        <Route path={RouteConstants.page6FooterTabs} element={<FooterTabs />} />
        {/*===============================================
        ==========Promise Management Routes=============
        ==================================================*/}
        <Route
          path={RouteConstants.promiseManagementDashboard}
          element={<PromiseManagementDashboard />}
        />
        <Route
          path={RouteConstants.promiseCreation}
          element={<PromiseCreation />}
        />
        <Route path={RouteConstants.promiseList} element={<PromiseList />} />
        {/*===============================================
        ==========Resource Management Routes=============
        ==================================================*/}
        <Route
          path={RouteConstants.resourceManagementDashboard}
          element={<ResourceManagementDashboard />}
        />
        <Route path={`${RouteConstants.faqList}`} element={<FAQList />} />
        <Route
          path={`${RouteConstants.faqCreation}`}
          element={<FAQCreation />}
        />
        <Route path={RouteConstants.insightList} element={<InsightList />} />
        <Route path={RouteConstants.insightQrGeneration} element={<QrCodeGeneration/>} />
        <Route
          path={RouteConstants.insightCreation}
          element={<InsightsCreation />}
        />
        <Route path={RouteConstants.faqList} element={<FAQList />} />
        {/*===============================================
        ==========Marketing Management Routes=============
        ==================================================*/}
        <Route
          path={RouteConstants.marketingManagementDashboard}
          element={<MarketingManagementDashboard />}
        />
        <Route
          path={RouteConstants.promotionsAndOffersList}
          element={<PromotionsAndOffersList />}
        />
        <Route
          path={RouteConstants.promotionAndOffersCreation}
          element={<PromotionsAndOffersCreation />}
        />
        <Route
          path={RouteConstants.nudgeCardList}
          element={<NudgeCardList />}
        />
        <Route
          path={RouteConstants.nudgeCardCreation}
          element={<NudgeCardCreation />}
        />
        <Route
          path={RouteConstants.referralCardList}
          element={<ReferralCardList />}
        />
        <Route
          path={RouteConstants.referralCardCreation}
          element={<ReferralCardCreation />}
        />
        <Route path={RouteConstants.updateList} element={<UpdateList />} />
        <Route
          path={RouteConstants.updateCreation}
          element={<UpdateCreation />}
        />
        <Route
          path={RouteConstants.testimonialsList}
          element={<TestimonialList />}
        />
        <Route
          path={RouteConstants.testimonialCreation}
          element={<TestimonialCreation />}
        />
        <Route
          path={RouteConstants.mediaAndPrList}
          element={<MediaAndPrList />}
        />
        <Route
          path={RouteConstants.mediaAndPrCreation}
          element={<MediaAndPrCreation />}
        />
        {/*===============================================
        ==========Notification Management Routes=============
      ==================================================*/}
        <Route
          path={RouteConstants.notificationManagementDashboard}
          element={<NotificationManagementDashboard />}
        />
        <Route
          path={RouteConstants.notificationList}
          element={<NotificationList />}
        />
        <Route
          path={RouteConstants.notificationCreation}
          element={<CreateNotification />}
        />
        {/* <Route path={RouteConstants.appUpdates} element={<AppUpdates />} />
        <Route
          path={RouteConstants.appUpdateCreation}
          element={<CreateAppUpdate />}
        /> */}
        {/*===============================================
        ================Initial Routes===================
        ==================================================*/}
        <Route
          path="/"
          element={<Navigate to={getInitialRouteAfterLogin()} />}
        />
        <Route
          path="*"
          element={<Navigate to={getInitialRouteAfterLogin()} />}
        />
        {/*===============================================
        ================Chat Management Routes===================
        ==================================================*/}
        <Route
          path={RouteConstants.chatSupportManagementDashboard}
          element={<ChatSupportManagement />}
        />
        <Route path={RouteConstants.hoablNewUser} element={<HoablNewUser />} />
        <Route
          path={RouteConstants.projectsNewUser}
          element={<ProjectsNewUser />}
        />
        <Route
          path={RouteConstants.hoablInvestedUser}
          element={<HoablInvestedUser />}
        />
        <Route
          path={RouteConstants.projectsInvestedUser}
          element={<ProjectsInvestedUser />}
        />
        <Route path={RouteConstants.schedulingVC} element={<SchedulingVC />} />
        {/*===============================================
        ================Customer Management Routes===================
        ==================================================*/}
        <Route
          path={RouteConstants.customerManagementDashboard}
          element={<CustomerList />}
        />
        <Route path={RouteConstants.customerList} element={<CustomerList />} />
        <Route
          path={RouteConstants.customerFeedback}
          element={<CustomerFeedback />}
        />
        <Route
          path={RouteConstants.blockedCustomersList}
          element={<BlockedCustomersList />}
        />
        <Route path={RouteConstants.customerView} element={<CustomerView />} />
        <Route
          path={RouteConstants.customerInvestmentDetails}
          element={<CustomerInvestmentDetails />}
        />
        <Route
          path={RouteConstants.blogManagementDashboard}
          element={<BlogManagementDashboard />}
        />
        <Route path={RouteConstants.blogCreation} element={<BlogCreation />} />
        <Route path={RouteConstants.blogs} element={<BlogList />} />
        <Route
          path={RouteConstants.landingPageManagementDashboard}
          element={<LandingPageManagementDashboard />}
        />
        <Route path={RouteConstants.urlList} element={<UrlList />} />
        <Route
          path={RouteConstants.landingPageUrlCreation}
          element={<LandingPageUrlCreation />}
        />

        {/*===============================================
        ================Chat Management Routes===================
        ==================================================*/}
        {/* <Route
          path={RouteConstants.paymentFormManagement}
          element={<PaymentFormManagement />}
        />
        <Route path={`${RouteConstants.projects}/*`} element={<Projects />} /> */}
        <Route
          path={RouteConstants.paymentFormManagement}
          element={<PaymentFormManagement />}
        >
          <Route index element={<ProjectFormList />} />
          <Route
            path={RouteConstants.formLists}
            element={<ProjectFormList />}
          />
          <Route path={RouteConstants.projects} element={<Projects />} />
        </Route>
        <Route
          path={RouteConstants.upCommingProject}
          element={<UpcommingProject />}
        />
        <Route
          path={RouteConstants.singleUpcommingProject}
          element={<SingleUpcommingProject />}
        />
        <Route
          path={RouteConstants.upCommingProjectUpdate}
          element={<UpdateUpcommingProject />}
        />
        <Route path={RouteConstants.leadsList} element={<LeadsList />} />



        {/* TODO: Commented because not tested on UAT yet and need to release  */}
        {/* ################## PAYMENT HISTORY ROUTES ###################### 
        <Route
          path={RouteConstants.paymentHistory}
          element={<PaymentHistory />}
        >
          <Route index element={<PaymentHistoryListing />} />
          
        </Route> */}

      </Route>
    );
  }

  return (
    <div>
       <Suspense fallback={<Loader/>}>
        <Routes>{routes}</Routes>
      </Suspense>
    </div>
  );
};

export default AppRoutes;
